const messages = {
  title: "Hjem",
  welcomeMessage:
    'Velkommen til BRIDGESTONE <span class="text-danger">PLUS</span>, %{first_name} %{last_name}',
  home: "Hjem",
  search: "Søk etter",
  sortBy: "Sorter etter",
  seeMore: "Se mer",
  bankstatement: {
    yourScore: "Ditt noverande antall markedsføringspoeng:",
    lastUpdate: "Sist oppdatert:",
    link: "Oversikt over punktbalanse",
  },
  shop: {
    bestSold: "Mest solgt",
    seasonal: "Sesong",
    affordable: "Overkommelig",
    forPoints: "for {points} poeng",
    reachedPoints: "Nødvendige poeng oppnådd",
    cartRemainPoints: "Atteståande poeng",
    remainingPoints: "{points} poeng attestår",
    noProducts: "Søkekriteriene ga ingen treff",
    variant: "Varianter tilgjengelig",
  },
  showAllProducts: "Gå til butikk",
  shopClosedBanner:
    "<div>BRIDGESTONE <span class='text-danger'>PLUS</span> SHOP</div><div>er snart tilgjengelig igjen.</div>",
};

export default {
  messages,
};
